import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Add, HighlightOff } from '@material-ui/icons';
import { CircularProgress, Button } from '@material-ui/core';

import DataTable from '../../components/Table/DataTable';
import AdminModal from './../../components/AdminModal';
import SearchBox from './../../components/SearchBox/SearchBox';

import { showAlert } from '../../store/ducks/alert';
import { getBlackListEmails, getBlackListEmailsBySearch, addEmailToBlackList, removeEmailFromBackList } from '../../services/blackList';

const BlackList = ({ location, match }) => {
  const dispatch = useDispatch();
  const [blackListEmails, setBlackListEmails] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });

  const [formData, setFormData] = useState({});
  const [open, setOpen] = useState(false);
  const [tagId, setTagId] = useState();
  const [slug, setSlug] = useState();

  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);

  useEffect(() => {
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    displayBlackList();
  }, [isSearching, page]);

  useEffect(() => {
    document.addEventListener('keydown', escape, false);

    return () => {
      document.removeEventListener('keydown', escape, false);
    };
  }, []);

  const escape = useCallback(event => {
    if (event.keyCode === 27) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
      window.history.pushState({ searching: true }, 'Searching', '/' + window.location.href.split('/')[3]);
    }
  }, []);

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const headers = ['id', 'email', 'reason', 'createdAt'];

  const modalColumns = [
    { label: 'Email', prop: 'email', type: 'text', required: true },
    { label: 'Reason', prop: 'reason', type: 'text', required: true },
  ];

  const handleCloseModal = () => {
    setFormData({});
    setOpen(false);
  };

  const handleOpenModal = () => {
    setOpen(true);
  };

  const handleAddUserToBlackList = async blackListData => {
    try {
      const { email, reason } = blackListData;
      if (email && reason) {
        await addEmailToBlackList(email, reason);
        dispatch(showAlert('success', 'Email added'));
      }
    } catch (error) {
      dispatch(showAlert('error', 'Something went wrong'));
    }
  };

  const handleRemoveUserFromBlackList = async email => {
    try {
      if (email) {
        await removeEmailFromBackList(email);
        dispatch(showAlert('success', 'Email removed'));
      }
    } catch (error) {
      dispatch(showAlert('error', 'Something went wrong'));
    }
  };

  const customActions = [
    {
      icon: <HighlightOff titleAccess='Remove Email from Black List' />,
      action: item => {
        handleRemoveUserFromBlackList(item.email);
      },
    },
  ];

  const displayBlackList = async () => {
    try {
      setIsLoading(true);
      let blackListEmails;
      if (isSearching) {
        const { data } = await getBlackListEmailsBySearch(searchField.searchItem, searchField.search);
        blackListEmails = data;
      } else if (!isSearching && Object.keys(match.params).length === 0) {
        const { data } = await getBlackListEmails(page);
        blackListEmails = data;
      }
      if (!blackListEmails) return;

      setBlackListEmails(blackListEmails.rows);
      setTotalItems(blackListEmails.count);
      setTotalPages(blackListEmails.pages);
      setPage(blackListEmails.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>Black List Emails ({totalItems})</h1>

        <SearchBox selectItems={['reason', 'email']} onSubmitSearch={handleSubmitSearch} isSearching={isSearching} onKeyDown={escape} />
        <Button className="register-btn" variant="contained" color="primary" startIcon={<Add />} onClick={handleOpenModal}>
          Register Email
        </Button>
      </div>

      {open ? (
        <AdminModal
          columns={modalColumns}
          data={formData}
          modalName="Add Email to Black List"
          onSubmit={handleAddUserToBlackList}
          onClose={handleCloseModal}
        />
      ) : (
        ''
      )}

      <DataTable
        useUid={false}
        head={headers}
        body={blackListEmails}
        action={true}
        isSlug
        customActions={customActions}
        bodyColumn={headers}
        linkPath={'blackList'}
        totalPages={totalPages}
        currentPage={page}
        setPageChange={setPage}
      />
    </>
  );
};

export default BlackList;
